module.exports = __webpack_public_path__ + "img/104.4cfe41e2.jpg";